/* Baleština – The Hold theme layer */
(function(){
  var d=document,H=window.HUG||{};
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  function money(c){
    var f=H.money||'${{amount}}',a=(c/100).toFixed(2);
    return f.split('{{amount_no_decimals}}').join(String(Math.round(c/100)))
      .split('{{amount_with_comma_separator}}').join(a.replace('.',',').replace(',00',''))
      .split('{{amount}}').join(a.replace('.00',''));
  }
  function each(s,fn,ctx){[].forEach.call((ctx||d).querySelectorAll(s),fn)}

  var hd=d.querySelector('.hg-hdr');
  if(hd){var st=function(){hd.classList.toggle('is-stuck',window.scrollY>8)};window.addEventListener('scroll',st,{passive:true});st();}

  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px'});
    each('.hg-rev',function(e){io.observe(e)});
  } else { each('.hg-rev',function(e){e.classList.add('is-in')}); }

  each('[data-hug-scroller]',function(w){
    var t=w.querySelector('[data-track]');if(!t)return;
    each('[data-dir]',function(b){b.addEventListener('click',function(){t.scrollBy({left:Number(b.getAttribute('data-dir'))*t.clientWidth*0.85,behavior:'smooth'})})},w);
  });

  each('[data-hug-story]',function(s){
    var ms=s.querySelectorAll('.hg-story__stick .hg-story__m'),cs=s.querySelectorAll('.hg-ch');
    if(cs[0])cs[0].classList.add('is-on');
    if(!('IntersectionObserver' in window)){[].forEach.call(cs,function(c){c.classList.add('is-on')});return;}
    var o=new IntersectionObserver(function(es){es.forEach(function(e){
      if(!e.isIntersecting)return;var c=e.target,m=c.getAttribute('data-m');
      [].forEach.call(cs,function(x){x.classList.toggle('is-on',x===c)});
      [].forEach.call(ms,function(x){x.classList.toggle('is-on',x.getAttribute('data-i')===m)});
    })},{rootMargin:'-45% 0px -45% 0px'});
    [].forEach.call(cs,function(c){o.observe(c)});
  });

  /* free ebook: add it once per cart (an automatic discount makes it $0) */
  function addBonus(){
    if(!H.bonus)return Promise.resolve();
    return fetch(root+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){
      var has=(c.items||[]).some(function(i){return String(i.variant_id)===String(H.bonus)});
      if(has)return;
      return fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(H.bonus),quantity:1}]})});
    }).catch(function(){});
  }

  d.addEventListener('submit',function(e){
    var f=e.target;if(!f.hasAttribute||!f.hasAttribute('data-hug-form'))return;
    e.preventDefault();
    var bs=[].slice.call(f.querySelectorAll('[type=submit]'));
    if(f.id)bs=bs.concat([].slice.call(d.querySelectorAll('button[form="'+f.id+'"]')));
    bs.forEach(function(b){b.disabled=true;b.classList.add('is-busy')});
    var err=f.querySelector('[data-err]');
    if(!err){err=d.createElement('p');err.className='hg-err';err.setAttribute('data-err','');err.setAttribute('role','alert');f.appendChild(err)}
    err.hidden=true;
    fetch(root+'cart/add.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:new FormData(f)})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
      .then(addBonus)
      .then(function(){window.location.href=root+(H.after==='cart'?'cart':'checkout')})
      .catch(function(j){
        bs.forEach(function(b){b.disabled=false;b.classList.remove('is-busy')});
        err.textContent=(j&&(j.description||j.message))||'Something went wrong. Please try again.';err.hidden=false;
      });
  });

  var p=d.querySelector('[data-hug-pdp]');
  if(p){
    var vj=p.querySelector('[data-variants]'),vs=vj?JSON.parse(vj.textContent):[];
    var f=p.querySelector('form[data-hug-form]'),idIn=f&&f.querySelector('input[name=id]');
    var track=p.querySelector('[data-track]'),thumbs=[].slice.call(p.querySelectorAll('[data-thumb]')),cnt=p.querySelector('[data-gal-i]');
    var go=function(i){if(track)track.scrollTo({left:i*track.clientWidth,behavior:'smooth'})};
    thumbs.forEach(function(b){b.addEventListener('click',function(){go(Number(b.getAttribute('data-thumb')))})});
    if(track){var tk;track.addEventListener('scroll',function(){clearTimeout(tk);tk=setTimeout(function(){
      var i=Math.round(track.scrollLeft/track.clientWidth);
      thumbs.forEach(function(b,k){b.classList.toggle('is-on',k===i)});if(cnt)cnt.textContent=i+1;},60)},{passive:true});}
    var upd=function(user){
      if(!f)return;
      var a=f.querySelector('[name=hug-o1]:checked'),b=f.querySelector('[name=hug-o2]:checked');
      var o1=a?a.value:null,o2=b?b.value:null;
      each('.hg-pack',function(l){l.classList.toggle('is-on',l.querySelector('input').checked)},p);
      each('[data-colour-name]',function(e){if(o2)e.textContent=o2},p);
      var sec=p.querySelector('[data-second]');
      if(sec){var two=sec.getAttribute('data-pack')===o1;sec.hidden=!two;var ss=sec.querySelector('select');if(ss)ss.disabled=!two;}
      var v=vs.filter(function(x){return (o1===null||x.option1===o1)&&(o2===null||x.option2===o2)})[0];
      if(!v)return;
      idIn.value=v.id;
      var hasC=v.compare_at_price&&v.compare_at_price>v.price;
      each('[data-price]',function(e){e.textContent=money(v.price)});
      each('[data-atc-price]',function(e){e.textContent=money(v.price)});
      each('[data-compare]',function(e){e.textContent=hasC?money(v.compare_at_price):''},p);
      each('[data-save]',function(e){e.hidden=!hasC;if(hasC)e.textContent=(e.getAttribute('data-label')||'Save')+' '+money(v.compare_at_price-v.price)},p);
      each('[data-sticky-v]',function(e){e.textContent=v.title});
      each('button[form="'+f.id+'"],#'+f.id+' [type=submit]',function(e){e.disabled=!v.available});
      if(user&&v.featured_media){var sl=p.querySelector('[data-media-id="'+v.featured_media.id+'"]');if(sl)go([].indexOf.call(sl.parentNode.children,sl));}
      if(user){try{var u=new URL(window.location.href);u.searchParams.set('variant',v.id);history.replaceState(history.state,'',u.toString())}catch(x){}}
    };
    if(f){f.addEventListener('change',function(e){var n=e.target.name;if(n==='hug-o1'||n==='hug-o2')upd(true)});upd(false);}
    var nt=p.querySelector('[data-note-toggle]'),nb=p.querySelector('[data-note]');
    if(nt&&nb){nt.addEventListener('change',function(){nb.hidden=!nt.checked;var ta=nb.querySelector('textarea');if(ta){ta.disabled=!nt.checked;if(nt.checked)ta.focus()}})}
    var sb=d.querySelector('[data-sticky]'),atc=p.querySelector('.hg-atc');
    if(sb&&atc&&'IntersectionObserver' in window){new IntersectionObserver(function(es){es.forEach(function(e){sb.classList.toggle('is-on',!e.isIntersecting&&e.boundingClientRect.top<0)})}).observe(atc);}
  }
})();
